export default "__VITE_ASSET__ISvkZqbT__"